import React, { useState } from "react";
import { Col, Modal, Nav, Row, Tab, Image, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from 'react-router-dom';


const DocumentsModulesEdit = ({data}:{data:any}) => 
{
  
  const params = useParams();
  const { categoryId }: any = params;
    
    return (
      <>
        <a
          href={
            categoryId
              ? `/document/details/${categoryId}`
              : `/documentmodulesDetails`
          }
        >
          <b>
            VIEW ALL
            <span style={{ fontSize: '18px' }}>{' >'}</span>
          </b>
        </a>
      </>
    );
    };

export default DocumentsModulesEdit;
